import jQuery from 'jquery';

jQuery(function ($) {
  // スマホのみ商品ページのショップリンクと詳細を開く
  if (window.matchMedia('(max-width: 768px)').matches) {
    $('#js-open-cart').on('click', function () {
      $('#js-cart-content').slideToggle();
      $(this).toggleClass('is-active');
    });

    $('#js-open-details').on('click', function () {
      $('#js-details-content').slideToggle();
      $(this).toggleClass('is-active');
    });
  }

  // スマホのみヘッダーを固定する
  if (window.matchMedia('(max-width: 768px)').matches) {
    $('#header').addClass('isFixed');

    // TOPページのみメインビジュアルの下からヘッダーに背景を付与
    var path = location.pathname;
    if (path === '/') {
      $(window).on('scroll', function () {
        let scrollTop = $(window).scrollTop();
        const target = $('#js-hasBackground').offset().top;

        if (scrollTop > target) {
          $('#header').addClass('hasBackground');
        } else {
          $('#header').removeClass('hasBackground');
        }
      });
    }
  }
});
